import Api from './Api';
import Configuracao from '../util/Configuracao';

class LimiteCobrancaApi extends Api {
  async consultarLimites () {
    try {
      const limitesUrl = Configuracao.getConfiguracao().limitesUrl;
      const response = await this.fetch(limitesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarUltimoLimite () {
    try {
      const urlConsultarUltimoLimite = Configuracao.getConfiguracao().urlConsultarUltimoLimite;
      const response = await this.fetch(urlConsultarUltimoLimite);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirLimite (limite) {
    try {
      const urlIncluirLimite = Configuracao.getConfiguracao().urlIncluirLimite;
      const response = await this.fetch(urlIncluirLimite, 'put', limite);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirLimite (codVigencia) {
    try {
      const urlExcluirLimite = Configuracao.getConfiguracao().urlExcluirLimite + '/' + codVigencia;
      const response = await this.fetch(urlExcluirLimite, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarLimite (limite) {
    try {
      const urlAlterarLimite = Configuracao.getConfiguracao().urlAlterarLimite;
      const response = await this.fetch(urlAlterarLimite, 'put', limite);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default LimiteCobrancaApi;
